export default __webpack_public_path__ + "static/media/logo_icon.cc12c69d.svg";